import { useCallback, useEffect, useState } from "react";

export interface ElementSize {
  width: number;
  height: number;
}

const borderBoxSize = (element: Element): ElementSize => {
  const { width, height } = element.getBoundingClientRect();
  return { width, height };
};

export const useElementSize = () => {
  const [element, setElement] = useState<HTMLElement | null>(null);
  const [size, setSize] = useState<ElementSize | null>(null);

  // Measuring when the node attaches gives a size before the first paint, so
  // consumers never paint their fallback for a null size.
  const ref = useCallback((node: HTMLElement | null) => {
    setElement(node);
    setSize(node === null ? null : borderBoxSize(node));
  }, []);

  useEffect(() => {
    if (element === null) {
      return;
    }
    const observer = new ResizeObserver(() => {
      setSize(borderBoxSize(element));
    });
    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  }, [element]);

  return { ref, size };
};
